import React from 'react';
import {strings} from '../../../../../common/resources/locales/i18n';
import {Link} from 'react-router-dom';

//Components
import { AsyncImage } from '../../../components/AsyncImage';

//Resources
import ModelsManager from "../../../../../common/modules/models/ModelsManager";

const ModelsItemNoStock = (props) => {
  const { description, image, urlRedirect, configuratorText, alt, backgroundColor, tags } = props;

  return (
    <div className="card card-model no-stock h-100">
      <div className="backColor color-bg" style={{backgroundColor: backgroundColor || "var(--primary)"}}></div>

      <div className="card-header position-relative pb-0">

        {tags && tags.map((item, key)=>{
          const backgroundHexColor = ModelsManager.getBackgroundHexColor(item)
          const tagText = ModelsManager.getTagText(item)
          const textHexColor = ModelsManager.getTextHexColor(item)

          return(
            <div key={key} className="card-tag bg-new small" style={{backgroundColor: backgroundHexColor, color: textHexColor }}>
              {tagText || ''}
            </div>
          )
        })}

        <figure className="embed-responsive embed-responsive-16by9 mb-0">
          <AsyncImage
            styleContainer='item'
            source={image}
            style='card-img-top embed-responsive-item'
            minHeightLoading='184px'
            alt={alt}
          />
        </figure>
      </div>
      <div className="card-body text-center pt-4">
        <div className="text-secondary mb-2 small-md">{strings("models.tmpOutStock")}</div>
        <h3 className="h4 text-muted">{description}</h3>
        <div className="card-body-hidden">
          <Link to={{ pathname: urlRedirect }} className="btn btn-sm btn-outline-primary btn-block" target="_blank" >
            {configuratorText}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default ModelsItemNoStock
